import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { gsap, Power3 } from "gsap";
import CurrencyInput from "./CurrencyInput";
import { useAppDispatch } from "../store/hooks";
import { updateFormState, updateStep } from "../userSlice";

const BASE_URL = "https://v6.exchangerate-api.com/v6/";
const ACCESS_KEY = "6b0be1ba2cc439a8728933f9";

interface Props {
  handleNext: () => void;
}

function Amount({ handleNext }: Props): JSX.Element {
  const [currencyOptions, setCurrencyOptions] = useState<
    null | undefined | any
  >([]);
  const [fromCurrency, setFromCurrency] = useState<null | undefined | any>();
  const [toCurrency, setToCurrency] = useState<null | undefined | any>();
  const [exchangeRate, setExchangeRate] = useState<null | undefined | any>();
  const [amount, setAmount] = useState<number>(0);
  const [count, setCount] = useState<number>(0);
  const [amountInFromCurrency, setAmountInFromCurrency] = useState(true);
  const dispatch = useAppDispatch();

  let myFirstElement: HTMLDivElement | null | any = useRef(null);
  let mySecondElement: HTMLDivElement | null | any =
    useRef<HTMLDivElement>(null);
  let myThirdElement: HTMLDivElement | null | any =
    useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (count === 3) {
      gsap.from(myFirstElement, 1.5, {
        opacity: 0,
        ease: Power3.easeOut,
      });
      gsap.from(mySecondElement, 1.5, {
        opacity: 0,
        ease: Power3.easeOut,
        delay: 0.2,
      });
      gsap.from(myThirdElement, 1.5, {
        opacity: 0,
        ease: Power3.easeOut,
        delay: 0.2,
      });
    }
    return () => {};
  }, [amount, count]);

  let toAmount;
  let fromAmount;

  if (amountInFromCurrency && amount !== 0) {
    fromAmount = amount;
    toAmount = amount * exchangeRate;
  } else {
    toAmount = amount;
    fromAmount = amount / exchangeRate;
  }

  useEffect(() => {
    axios
      .get(`${BASE_URL}${ACCESS_KEY}/latest/USD`)
      .then(function (response) {
        const rates = response.data.conversion_rates;
        const base = response.data.base_code;
        setFromCurrency(base);
        const firstCurrency = Object.keys(rates)[1];
        setCurrencyOptions([base, ...Object.keys(rates)]);
        setToCurrency(firstCurrency);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (fromCurrency != null && toCurrency != null) {
      axios
        .get(`${BASE_URL}${ACCESS_KEY}/pair/${fromCurrency}/${toCurrency}`)
        .then(function (response) {
          // handle success
          const exchange = response.data.conversion_rate.toFixed(2);
          setExchangeRate(exchange);
          setCount((c) => c + 1);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    }
  }, [fromCurrency, toCurrency, amount]);
  console.log("==", count);
  const handleFromAmountChange = (e: any): void => {
    setAmount(e.target.value);
    setAmountInFromCurrency(true);
  };

  const handleToAmountChange = (e: any): void => {
    setAmount(e.target.value);
    setAmountInFromCurrency(false);
  };

  const data = {
    sendTo: amount,
    receiveFrom: toAmount,
    aftercharges: amount - 1.52,
    fromCurrency,
    toCurrency,
    exchangeRate,
  };

  const handleSaveToState = (e: any): void => {
    dispatch(updateFormState(data));
    dispatch(updateStep(1));
    handleNext();
  };

  return (
    <div className="flex justify-center  ">
      <div className=" bg-white mt-16  mb-6 container rounded-md p-8 lg:w-2/5">
        <h1 className="text-base font-medium text-blue-dark">
          One-time Payout
        </h1>
        <p className="text-sm text-grey-dark">Send money internationally</p>
        <form className=" mt-4" onSubmit={handleSaveToState}>
          <CurrencyInput
            title="You Send"
            margin=""
            currencyOptions={currencyOptions}
            selectedCurrency={fromCurrency}
            onChangeCurrency={(event: any) =>
              setFromCurrency(event.target.value)
            }
            onChangeAmount={handleFromAmountChange}
            amount={fromAmount}
          />

          {amount > 0 ? (
            <div className="my-3 ">
              <span className="h-2.5 border-l-2 border-grey-light ml-9 -mt-3 absolute" />
              {/* eslint-disable no-return-assign, no-param-reassign */}
              <div
                ref={(el) => (myFirstElement = el)}
                className="flex text-grey-dim ml-6"
              >
                <span className="mr-4 text-sm rounded-full transition duration-500 ease-in-out h-6 w-6  flex justify-center items-center  bg-grey-blur">
                  -
                </span>
                <span className="mr-4 text-sm">1.52 USD</span>
                <span className="text-sm">Transfer fee</span>
              </div>
              <span className="h-2.5 border-l-2 border-grey-light ml-9" />
              {/* eslint-disable no-return-assign, no-param-reassign */}
              <div
                ref={(el) => (mySecondElement = el)}
                className="flex text-grey-dim ml-6"
              >
                {/* eslint-disable-next-line no-return-assign */}
                <span className="mr-4 text-sm rounded-full transition duration-500 ease-in-out h-6 w-6 flex justify-center items-center bg-grey-blur">
                  =
                </span>
                <span className="mr-4 text-sm">
                  {amount - 1.52} {toCurrency}
                </span>
                <span className="text-sm">Amount we’ll convert</span>
              </div>
              <span className="h-2.5 border-l-2 border-grey-light ml-9" />
              {/* eslint-disable no-return-assign, no-param-reassign */}
              <div
                ref={(el) => (myThirdElement = el)}
                className="flex  text-blue-deep ml-6"
              >
                <span className="mr-4 text-sm rounded-full transition duration-500 ease-in-out h-6 w-6  flex justify-center items-center  bg-grey-blur">
                  x
                </span>
                <span className="mr-4 text-sm">{exchangeRate}</span>
                <span className="text-sm"> Guaranteed rate (1hr)</span>
              </div>
              <span className="h-2.5 border-l-2 border-grey-light ml-9 absolute" />
            </div>
          ) : null}

          <CurrencyInput
            title="Recipient gets"
            margin={amount > 0 ? "" : "mt-6 "}
            currencyOptions={currencyOptions}
            selectedCurrency={toCurrency}
            onChangeCurrency={(e) => setToCurrency(e.target.value)}
            onChangeAmount={handleToAmountChange}
            amount={toAmount}
          />
          <div className=" flex justify-between mt-8">
            <button
              type="button"
              // onClick={handleCompare}
              disabled
              className="w-5/12 h-12 border border-blue rounded text-sm text-blue"
            >
              Compare rates
            </button>
            <button
              type="submit"
              className="h-12 bg-gray-200 w-5/12 rounded text-sm text-white bg-blue"
              disabled={!amount}
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Amount;
